import React, { PureComponent } from 'react';
import { TabList, TabPanel, Tabs } from 'react-tabs';

import AdvancedSearchForm from './advanced_search/index';
import OffersList from './offers_list/index';
import { SeoBanner } from './SeoBanner';
import { createSeoTabs } from './SeoTabs';
import { T } from '../../../../../common/locale/translate';
import {
  seoRegionsTabsNumbers,
  offersListTabsIds,
  tabParameterNameToTabNumber
} from '../../../common/objects/consts';
import GermanOperatorsBanner from '../../../common/components/german_operators_banner/GermanOperatorsBanner';
import TabAccordion from '../../../common/components/accordion';

export default class OffersSeoWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: this.initialSelectedTabIndex(props)
    };
  }

  render() {
    const { selectedTab } = this.state;
    const region_information = this.props.region_information || {};
    const {
      photo,
      title,
      description,
      region_info,
      useful_info,
      map_data
    } = region_information;
    const is_from_germany = this.props.is_from_germany;
    const is_seo_banner_visible =
      !is_from_germany && photo && title && description;
    const are_seo_tabs_visible =
      !is_from_germany && !!this.props.region_information;
    const are_hints_visible = !is_from_germany && !is_seo_banner_visible;
    const is_region_info_tab_visible =
      are_seo_tabs_visible &&
      typeof region_info !== 'undefined' &&
      region_info.length > 0;
    const is_useful_info_tab_visible =
      are_seo_tabs_visible &&
      typeof useful_info !== 'undefined' &&
      useful_info.length > 0;
    const is_map_tab_visible =
      are_seo_tabs_visible &&
      typeof map_data !== 'undefined' &&
      map_data.length > 0;

    return (
      <section className="main-wrapper">
        {is_from_germany && <GermanOperatorsBanner />}
        <div className="seo-inner-wrapper wrapper no-padding">
          {is_seo_banner_visible && (
            <SeoBanner photo={photo} title={title} description={description} />
          )}
          <Tabs selectedIndex={selectedTab} forceRenderTabPanel={true}>
            <TabList
              className={`nav nav-tabs ${are_seo_tabs_visible ? 'active' : ''}`}
            >
              {createSeoTabs(
                this.changeTab,
                is_region_info_tab_visible,
                is_useful_info_tab_visible,
                is_map_tab_visible
              )}
            </TabList>

            {is_region_info_tab_visible && (
              <TabAccordion
                index={
                  seoRegionsTabsNumbers[
                    offersListTabsIds.SEO_REGION_INFORMATION
                  ]
                }
                selectedTab={selectedTab}
                headerIcon="fa-globe"
                headerName={T('seo_region_information')}
                switchActiveTab={() =>
                  this.switchActiveTab(
                    seoRegionsTabsNumbers[
                      offersListTabsIds.SEO_REGION_INFORMATION
                    ]
                  )
                }
              >
                <TabPanel>
                  <div
                    className="seo-region-info"
                    dangerouslySetInnerHTML={{ __html: region_info }}
                  />
                </TabPanel>
              </TabAccordion>
            )}
            {is_useful_info_tab_visible && (
              <TabAccordion
                index={
                  seoRegionsTabsNumbers[
                    offersListTabsIds.SEO_PRACTICAL_INFORMATION
                  ]
                }
                selectedTab={selectedTab}
                headerIcon="fa-question-circle-o"
                headerName={T('seo_practical_information')}
                switchActiveTab={() =>
                  this.switchActiveTab(
                    seoRegionsTabsNumbers[
                      offersListTabsIds.SEO_PRACTICAL_INFORMATION
                    ]
                  )
                }
              >
                <TabPanel>
                  <div
                    className="seo-region-info"
                    dangerouslySetInnerHTML={{ __html: useful_info }}
                  />
                </TabPanel>
              </TabAccordion>
            )}
            {is_map_tab_visible && (
              <TabAccordion
                index={seoRegionsTabsNumbers[offersListTabsIds.SEO_MAP]}
                headerIcon="fa-map-marker"
                headerName={T('seo_map')}
                switchActiveTab={() =>
                  this.switchActiveTab(
                    seoRegionsTabsNumbers[offersListTabsIds.SEO_MAP]
                  )
                }
                selectedTab={selectedTab}
              >
                <TabPanel>
                  <div
                    className="google-maps-iframe"
                    dangerouslySetInnerHTML={{ __html: map_data }}
                  />
                </TabPanel>
              </TabAccordion>
            )}
            <div className="offers-list wrapper no-padding">
              <section className="filters sticky">
                <AdvancedSearchForm params={this.props.params} />
              </section>
              <section className="offers-list-content">
                <OffersList
                  getBreadcrumbsList={this.props.getBreadcrumbsList}
                  params={this.props.params}
                  seo_params={this.props.seo_params}
                  curiosities={this.props.curiosities}
                  are_hints_visible={are_hints_visible}
                />
              </section>
            </div>
          </Tabs>
        </div>
      </section>
    );
  }

  initialSelectedTabIndex = props => {
    const is_from_germany = this.props.is_from_germany;
    const are_seo_tabs_visible =
      !is_from_germany && !!this.props.region_information;

    if (are_seo_tabs_visible) {
      const tabParamName = props.initial_params.tab;
      const tabNumberFromParams = tabParameterNameToTabNumber[tabParamName];

      return (
        tabNumberFromParams ||
        seoRegionsTabsNumbers[offersListTabsIds.SEO_OFFERS_LIST]
      );
    } else {
      return seoRegionsTabsNumbers[offersListTabsIds.SEO_OFFERS_LIST];
    }
  };

  changeTab = tabId => {
    const tabNumber = seoRegionsTabsNumbers[tabId];
    this.setState({ selectedTab: tabNumber });
  };

  switchActiveTab = index => {
    const isCurrentTabActive = this.state.selectedTab === index;
    this.setState({ selectedTab: isCurrentTabActive ? null : index });
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/index.js